<template>
  <v-row mt-3>
    <v-col cols="12" md="7">
      <h4 class="text-h4 mt-2 font-weight-medium">
        How much monthly income would your survivors need if you passed away?
      </h4>
    </v-col>
    <v-col cols="12" offset-md="2" md="3">
      <CurrencyDisplay
        v-model="amount"
        @update:model-value="$emit('update:modelValue', $event)"
        :label-id="'Survivor monthly income'"
      />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import Slider from '@/components/Inputs/Slider/Slider.vue';
import CurrencyDisplay from './CurrencyDisplay.vue';

const componentOptions: ComponentOptions = {
  name: 'SurvivorMonthlyIncome',
  components: {
    Slider,
    CurrencyDisplay,
  },
  mounted() {
    this.amount = this.modelValue;
  },
  props: {
    modelValue: {
      type: Number,
      required: true,
    },
    formInput: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    amount: 0,
  }),
};

export default defineComponent(componentOptions);
</script>
